
var ws = null

if (typeof WebSocket !== 'undefined') {
  ws = WebSocket
} else if (typeof MozWebSocket !== 'undefined') {
  ws = MozWebSocket
} else {
  ws = window.WebSocket || window.MozWebSocket
}

module.exports = ws



//////////////////
// WEBPACK FOOTER
// ./~/websocket-stream/ws-fallback.js
// module id = 966
// module chunks = 0